export enum QuoteFormCrudMode {
    Create = 1,
    View = 2,
    Edit = 3
}
